import type { ProposalBatch } from "@stockline/shared/types/ai/proposal"
import type { OfflineResourceConfig } from "../../../types"
import { PROPOSAL_BATCH_TABLE } from "./db"

export const proposalBatchConfig: OfflineResourceConfig<ProposalBatch> = {
  name: "proposal-batches",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // Eager, in the readiness set (default "reference" tier). The AI Proposals
  // pages (mobile `MobileAiProposals` + web) gate their loading state on this
  // resource being ready via `useSyncStatusMany`, which keys off
  // `lastFullFetchAt`. Only the eager REST full-fetch stamps that reliably;
  // the deferred background/SSE-replay path (STK-1324) left it unstamped —
  // notably on an empty table — so the proposals page hung on "Loading…"
  // forever. Pending proposals are a Tier-1 feature and low-volume, so keep
  // this eager rather than deferring it with the heavy history resources.
  endpoints: {
    full: "/api/v2/ai-proposals",
    delta: "/api/v2/ai-proposals/changes",
    push: "/api/v2/ai-proposals/changes",
  },
  tableName: PROPOSAL_BATCH_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    status: "status",
    toolName: "toolName",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
